import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class ThirdPartyReservationSource
 */
export class ThirdPartyReservationSource extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...ThirdPartyReservationSource.translatableAttributesWithLanguageAliases,
    'property',
    'parent_id',
    'parent',
    'status',
    'commission',
    'taxes_fees',
    'editable',
)(ThirdPartyReservationSource);



// WEBPACK FOOTER //
// ./src/pms-api/models/third-party-reservation-source.model.js